import { render, staticRenderFns } from "./AxCopyToClipboard.vue?vue&type=template&id=2e59eba6&scoped=true&"
import script from "./AxCopyToClipboard.vue?vue&type=script&lang=ts&"
export * from "./AxCopyToClipboard.vue?vue&type=script&lang=ts&"
import style0 from "./AxCopyToClipboard.vue?vue&type=style&index=0&id=2e59eba6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e59eba6",
  null
  
)

export default component.exports